export default __webpack_public_path__ + "static/media/0037.a36229ff.png";